import React from 'react';
import styles from './Emitir.module.css';

/* Faixa que separa as áreas dentro de uma mesma tela, usando o mesmo ícone
   e nome da trilha lá de cima. Serve pra juntar etapas curtas numa tela só
   sem perder a noção de onde começa cada parte -- e pra trilha continuar
   fazendo sentido, já que ela rola até a faixa correspondente. */
function FaixaSecao({ icone: Icone, titulo, ancora }) {
  return (
    <div className={styles.faixaSecao} id={ancora}>
      <span className={styles.faixaIcone}><Icone size={14} /></span>
      <span className={styles.faixaTitulo}>{titulo}</span>
      <span className={styles.faixaLinha} />
    </div>
  );
}

export default FaixaSecao;
